import { cva } from '@/styled-system/css';

export const progressStepperIconRecipe = cva({
  base: {
    display: 'flex',
    width: 'handle.sm',
    height: 'handle.sm',
  },
  variants: {
    tone: {
      complete: {
        color: 'ProgressMeter.Node.complete.icon',
        width: '250',
        height: '250',
      },
      incomplete: {
        color: 'ProgressMeter.Node.incomplete.icon',
        width: 'icon.xs',
        height: 'icon.xs',
      },
      critical: {
        color: 'ProgressMeter.Node.error.bg',
      },
      warning: {
        color: 'ProgressMeter.Node.warning.bg',
      },
      notStarted: {},
      none: {},
    },
    active: {
      true: {
        color: 'ProgressMeter.Node.complete.bg',
      },
      false: {},
    },
  },
});
